import { CardNumberMask } from "./CardNumberMask";
import { CepMask } from "./CepMask";
import { CpfMask } from "./CpfMask";
import { CurrencyMask } from "./CurrencyMask";
import { DateMask } from "./DateMask";
import { PhoneMask } from "./PhoneMask";
import { TimeMask } from "./TimeMask";

export const phoneMask = new PhoneMask();
export const cepMask = new CepMask();
export const cpfMask = new CpfMask();
export const currencyMask = new CurrencyMask();
export const dateMask = new DateMask();
export const cardNumberMask = new CardNumberMask();
export const timeMask = new TimeMask();
